<template>
  <span style="width: 100%; text-align: center; display: flex; justify-content: space-evenly; align-items: center; ">
    <v-btn class="btn-primary" dark @click="acceptByppass">
      {{ $t('Accept') }}
    </v-btn>
    <v-btn fab color="primary" dark @click="openModal">
      <v-icon>
        mdi-information-outline
      </v-icon>
    </v-btn>
    <v-btn color="secondary" class="black--text" @click="declineByppass">
      {{ $t('AcceptBypaymentChatComponent.Decline') }}
    </v-btn>

    <v-dialog :value="modalOpened"
              transition="dialog-bottom-transition"
              content-class="payment-information"
              @click:outside="clickedOutside">
      <template>
        <v-card>
          <div class="pa-5">
            <div>

              <v-card-text id="certificate" ref="document">
                <div ref="content" class="container">
                  <div class="row">
                    <div class="col">
                      <strong>{{ $t('Date') }}:</strong>
                    </div>
                    <div class="col">
                      {{ date }}
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <strong>{{ $t('Debtor (A)') }}:</strong>
                    </div>
                    <div class="col">
                      {{ getName(payer) }}
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <strong>{{ $t('Creditor (B)') }}:</strong>
                    </div>
                    <div class="col">
                      {{ getName(middle) }}
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <strong>{{ $t('Beneficiary (C)') }}:</strong>
                    </div>
                    <div class="col">
                      {{ getName(receiver) }}
                    </div>
                  </div>

<!--                  <div class="row">-->
<!--                    <div class="col">-->
<!--                      <strong>{{ $t('Compensated ammount') }}:</strong>-->
<!--                    </div>-->
<!--                    <div class="col">-->
<!--                      <div>-->
<!--                        {{ compensated }}€-->
<!--                      </div>-->
<!--                      <div>-->
<!--                        ({{ $t('Quantity that A deduces from his debt with B through a payment to C') }})-->
<!--                      </div>-->
<!--                    </div>-->
<!--                  </div>-->
                  <div class="row">
                    <div class="col">
                      <strong>{{ $t('Payment from debtor (A) to beneficiary (C)') }}:</strong>
                    </div>
                    <div class="col">
                      <div>
                        {{ payment }}€
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col">
                      <strong>{{ $t('Manifested agreement') }}:</strong>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      {{ $t('certificate.payer', {amount: chat.factoring.formulaCalc.earnA.toFixed(2)}) }}
                    </div>
                  </div>
                    
                  <div class="row">
                    <div class="col">
                      {{ $t('certificate.receiver', {amount: chat.factoring.formulaCalc.payed.toFixed(2), invoiceNumberBC: invoiceNumberBC }) }}
                      <a :href="invoiceLinkBC" target="_blank">link</a> ]
                      {{ $t('certificate.receiverP2', {amount: chat.factoring.formulaCalc.earnC.toFixed(2) }) }}
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      {{ $t('certificate.outstanding',{amount: chat.factoring.formulaCalc.ABini > chat.factoring.formulaCalc.BCini ? chat.factoring.formulaCalc.ABout.toFixed(2) :chat.factoring.formulaCalc.BCout.toFixed(2),
                                                       invoiceName : chat.factoring.formulaCalc.ABini > chat.factoring.formulaCalc.BCini ? 'A-B[' + chat.factoring.invoice_payer.number + ']':
                                                         'B-C[' + chat.factoring.invoice_receiver.number + ']'}) }}
                      <a :href="chat.factoring.formulaCalc.ABini > chat.factoring.formulaCalc.BCini? invoiceLinkAB : invoiceLinkBC" target="_blank">link</a> ]
                    </div>
                  </div>
                </div>
              </v-card-text>
            </div>
            <div style="display: flex; flex-direction: row-reverse;">
              <v-btn text color="#FF6961" @click="modalOpened = false">
                {{ $t('Cancel') }}
              </v-btn>
            </div>
          </div>
        </v-card>
      </template>
    </v-dialog>
  </span>
</template>

<script>
import ApiRepository from "../repositories/ApiRepository";
import Constants from "../../constants";
import Vue from "vue";
import moment from "moment/moment";
import {User} from "../models/user";
import {Factoring} from "../models/factoring";
export default {
    name: "AcceptBypaymentChatComponent",
    components: {},
    props: {
        chat: {type: Object, required: true}
    },
    data () {
        return {
            modalOpened: false,
            date: "",
            certificateNumber: "",
            invoiceP: null,
            invoiceR: null,
            factoringModel: null,
            userPayerModel: null,
            userMiddleModel: null,
            userReceiverModel: null,
            showModal: false,
            invoices: [],
            Constants: Constants,
            paymentStatusLine1: "",
            paymentStatusLine2: "",
            payer: null,
            middle: null,
            receiver: null,
            compensated: 0,
            payment: 0,
            paymentNoByto: 0,
            paymentByto: 0,
            paymentToPlatform: 0,
            paymentMiddleToReceiver: 0,
            account: "",
            invoiceNumberAB: "",
            invoiceLinkAB: "",
            invoiceLinkCompensated: "",
            invoiceNumberBC: "",
            invoiceLinkBC: "",
            invoiceLinkCleared: "",
            bonus: 0
        };
    },
    mounted () {

        this.date = moment(this.chat.factoring.created).format("DD/MM/YYYY ");
        if (this.chat.factoring.hash.length > 0) this.certificateNumber = this.chat.factoring.hash[0];
        this.chat.factoringModel = new Factoring(this.chat.factoring, this.$user, this.$parameters);
        this.userPayerModel = new User(this.chat.factoring.payer);
        this.userMiddleModel = new User(this.chat.factoring.middle);
        this.userReceiverModel = new User(this.chat.factoring.receiver);
        const lines = this.chat.factoringModel.paymentInformation();
        this.paymentStatusLine1 = lines.line1;
        this.paymentStatusLine2 = lines.line2;
        // -- //
        this.date = moment(this.chat.factoring.created).format("DD/MM/YYYY ");
        if (this.chat.factoring.hash.length > 0) this.certificateNumber = this.chat.factoring.hash[0];
        this.payer = new User(this.chat.factoring.payer);
        this.middle = new User(this.chat.factoring.middle);
        this.receiver = new User(this.chat.factoring.receiver);

        this.compensated = this.chat.factoring.compensation;
        if (this.chat.factoring.invoice_receiver.amount < this.chat.factoring.invoice_payer.amount) {
            this.compensated = this.chat.factoring.invoice_receiver.amount;
        } else {
            this.compensated = this.chat.factoring.invoice_payer.amount;
        }
        this.payment = this.chat.factoring.formulaCalc.ACclc;
        this.paymentNoByto = this.chat.factoring.formulaCalc.ACclc;
        this.paymentByto = this.chat.factoring.formulaCalc.ACclc + this.chat.factoring.formulaCalc.earnA;
        this.paymentToPlatform = this.chat.factoring.formulaCalc.earnP;
        this.account = this.chat.factoring.invoice_receiver.accountNumber;
        this.invoiceNumberAB = this.chat.factoring.invoice_payer.number;
        this.invoiceNumberBC = this.chat.factoring.invoice_receiver.number;
        this.invoiceLinkAB = "/viewInvoice?invoiceId=" + this.chat.factoring.invoice_payer._id;
        this.invoiceLinkBC = "/viewInvoice?invoiceId=" + this.chat.factoring.invoice_receiver._id;
        this.invoiceLinkCompensated = Constants.BLOCKCHAIN_URL + this.chat.factoring.hash[0];
        this.invoiceLinkCleared = Constants.BLOCKCHAIN_URL + this.chat.factoring.hash[0];
        this.bonus = this.chat.factoring.platformComission;
    },
    methods: {
        saveSecondInvoice (e) {
            const acceptedPaymentMethods = [];
            acceptedPaymentMethods.push(Constants.FACTORING_PAYMENT_METHODS.CRYPTO);
            acceptedPaymentMethods.push(Constants.FACTORING_PAYMENT_METHODS.OUTSIDE_PLATFORM);
            acceptedPaymentMethods.push(Constants.FACTORING_PAYMENT_METHODS.OPEN_BANKING);
            ApiRepository.createBypay(e.invoice, this.invoice, false, null, acceptedPaymentMethods).then(() => {
                this.$emit('createdByppass', {otherInvoice: e.invoice});
                this.modalOpened = false;
            }).catch(err => {
                console.log(err);
                this.$root.$emit('show-snackbar', {message: this.$t('Error.Something went wrong'), color: 'error'});
            });
        },
        backStep (e) {
            console.log("back");
            console.log(e);
        },
        nextStep (e) {
            console.log("next");
            console.log(e);
        },
        clickedOutside () {
            this.modalOpened = false;
        },
        openModal () {
            this.modalOpened = true;
        },
        acceptByppass () {
            const acceptedPaymentMethods = [];
            acceptedPaymentMethods.push(Constants.FACTORING_PAYMENT_METHODS.CRYPTO);
            acceptedPaymentMethods.push(Constants.FACTORING_PAYMENT_METHODS.OUTSIDE_PLATFORM);
            acceptedPaymentMethods.push(Constants.FACTORING_PAYMENT_METHODS.OPEN_BANKING);
            ApiRepository.setFactoring(this.$user._id, this.chat.factoring._id.toString(), this.chat._id.toString());
            ApiRepository.acceptByppayFromUser(this.middle.user._id.toString(), acceptedPaymentMethods, false, this.chat.factoring._id.toString()).then((res) => {
                ApiRepository.setInvoicePercentage('byppay_accepted', this.chat.invoice._id).then(() => {
                    this.$emit('accepted');
                });
            });
        },
        declineByppass () {
            ApiRepository.declineByppays(this.middle.user._id.toString(), false, this.chat.factoring._id.toString()).then((res) => {
                this.$emit('decline');
            });
        },
        getName (user) {
            if (user) {
                return user.getName();
            }
            return "";
        },
        saveForm () {
            this.modalOpened = true;
        },
    }
};
</script>

<style scoped>
.divider{
    padding: 0 0 18px 0;
}
>>> .payment-information {
    align-self: flex-end;
}
>>> .v-text-field--outlined .v-label {
    top: 9px !important;
}
</style>
